import "./userheader.scss";
import AvatarDropdownMenu from "../../../../ui/dropdownmenu/avatardropdownmenu/avatardropdownmenu";
import Notification from "../../../../ui/notification/notification";
import useMediaQuery from '@mui/material/useMediaQuery';
import UserCredit from "../../../../ui/usercredit/usercredit";
import * as React from "react";

interface IUserHeader {
    credit: string
    profile: string
    name: string
    job: string
    open: boolean
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
    notification: boolean
}

const UserHeader = ({credit, profile, name, job, notification, open, setOpen}: IUserHeader) => {
    const matches = useMediaQuery('(max-width:768px)');
    return (
        <div className="User-Header">
            {matches ? null : <UserCredit credit={credit}/>}
            {matches ?
                <div onClick={() => {
                    setOpen(!open)
                }
                } className="Menu-Icon">

                </div>
                :
                null
            }
            <div className="d-flex justify-content-end" style={{gap: '15px'}}>
                <Notification hasNotification={notification}/>
                <AvatarDropdownMenu
                    name={name}
                    job={job}
                    profile={profile}
                    menuItems={
                        [
                            {
                                title: 'آپشن تست برای دراپ دون 1', action: () => {
                                }
                            },
                            {
                                title: 'آپشن تست برای دراپ دون 2', action: () => {
                                }
                            },
                        ]
                    }
                />
            </div>
        </div>
    );

}

export default UserHeader;